(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('ShiftType', ShiftType);

    ShiftType.$inject = ['$resource'];

    function ShiftType ($resource) {
        var resourceUrl =  'api/shift-types/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/shift-types/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
